// extracted by mini-css-extract-plugin
export default {"team":"YrfA1VZCPDgoREbN5hDv","h2":"eStHH7Q6XHYNhiNKjBHI","items":"RkFFAVOOEZ16fo45kPf_"};